import React from "react";
import moment from "moment";
import { TAnnex6V2Record } from "redux/app/annex6-v2/@types";
import { TAnnex6V2GroupC3 } from "redux/app/annex6-v2/groups/group-c";
import Annex6V2TableRows from "../Annex6V2TableRows";

type OwnProps = {
	annex6V2Record: TAnnex6V2Record;
	isStrikedOff?: boolean;
	theme?: "light" | "dark";
};
type Annex6V2GroupC3PreviewProps = OwnProps;

function Annex6V2GroupC3Preview(props: Annex6V2GroupC3PreviewProps) {
	const record = props.annex6V2Record as TAnnex6V2GroupC3;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);
	const { itemC0, itemC3P1 } = record;

	function renderMain() {
		const tableRows = [
			[operationDate, "C", "5", renderItemP1()],
			[null, null, "NOTE", record.remarks],
		];

		return (
			<Annex6V2TableRows
				record={record}
				tableRows={tableRows}
				theme={props.theme}
			/>
		);
	}

	function renderItemP1() {
		const { date: smtDate, time: smtTime } = itemC3P1;
		const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
		const utcTime = moment.utc(dateTimeLocal);

		return (
			<h4 className="font-medium uppercase">
				ECA {itemC0.entryOrExit} at {utcTime.format("HH:mm")} hrs UTC on{" "}
				{utcTime.format("DD-MMM-YYYY")} ({smtTime} SMT on{" "}
				{moment(smtDate, "YYYY-MM-DD").format("DD-MMM-YYYY")})
			</h4>
		);
	}

	return renderMain();
}

export default Annex6V2GroupC3Preview;
